/**
 * W-11 支付成功(WScreen-11)。纯前端展示页,**无接口、不校验订单态**(payment-success.md)。
 * 克制不庆祝(不撒花)。双 CTA 是唯一合法出口,不自动导航。params 缺失优雅降级。
 * 视觉真源 design/payment-success.html。
 */
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { formatAmount } from '@/lib/orderState';

interface SuccessState {
  amount?: number;
  sellerNickname?: string;
  sellerAvatar?: string | null;
}

export function PaymentSuccessPage() {
  const navigate = useNavigate();
  const { orderId } = useParams<{ orderId: string }>();
  const state = (useLocation().state as SuccessState | null) ?? {};
  const { amount, sellerNickname } = state;

  const orderLine = [orderId ? `订单号 ${orderId}` : null, sellerNickname ? `卖家 ${sellerNickname}` : null]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="inner section">
      <div
        className="card card-pad"
        style={{
          maxWidth: 520,
          margin: 'var(--space-12) auto',
          textAlign: 'center',
          padding: 'var(--space-12) var(--space-8)',
        }}
      >
        <div
          aria-hidden
          style={{
            width: 64,
            height: 64,
            borderRadius: 'var(--radius-full)',
            background: 'var(--color-primary)',
            color: 'var(--color-primary-foreground)',
            fontSize: 34,
            lineHeight: '64px',
            margin: '0 auto var(--space-6)',
          }}
        >
          ✓
        </div>
        <h1 className="h2 mb-3">支付成功</h1>

        {typeof amount === 'number' && (
          <div
            className="price mb-2"
            style={{ fontSize: 'var(--text-4xl-size)', lineHeight: 'var(--text-4xl-line)' }}
          >
            {formatAmount(amount)}
          </div>
        )}
        {orderLine && <div className="xs muted mb-6">{orderLine}</div>}

        <div
          className="row between"
          style={{
            padding: 'var(--space-3) var(--space-4)',
            background: 'var(--color-secondary)',
            borderRadius: 'var(--radius-md)',
            marginBottom: 'var(--space-8)',
          }}
        >
          <span className="sm muted">卖家已收到通知</span>
          <span className="sm">交易完成后 T+7 自动结算</span>
        </div>

        <button
          type="button"
          className="btn btn-primary btn-lg btn-block mb-3"
          onClick={() => navigate(orderId ? `/orders/${orderId}` : '/orders')}
        >
          查看订单
        </button>
        <button
          type="button"
          className="btn btn-secondary btn-block"
          onClick={() => navigate('/')}
        >
          继续逛逛
        </button>
      </div>
    </div>
  );
}
